import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
} from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { deleteObject, getStorage, ref } from 'firebase/storage';
import { useEffect, useRef, useState } from 'react';
import { uploadPhotoToStorage } from '../functions/sendMessage';

const Marketplace = () => {
  const db = getFirestore();
  const fileInputRef = useRef(null);
  const [products, setProducts] = useState([]);
  const [newProduct, setNewProduct] = useState({
    img: null,
    name: '',
    description: '',
    price: '',
    volume: '',
    weight: '',
    position: products.length ?? 20,
    visible: true,
  });
  const [editingProduct, setEditingProduct] = useState(null);

  useEffect(() => {
    const productsRef = collection(db, `marketplace`);
    const q = query(productsRef, orderBy('position', 'asc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const productsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProducts(productsData);
    });
    return () => unsubscribe();
  }, [db]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (editingProduct) {
      if (type === 'file') {
        setEditingProduct({ ...editingProduct, img: files[0] });
      } else {
        setEditingProduct({ ...editingProduct, [name]: value });
      }
    } else {
      if (type === 'file') {
        setNewProduct({ ...newProduct, img: files[0] });
      } else {
        setNewProduct({ ...newProduct, [name]: value });
      }
    }
  };

  const handleAddProduct = async (e) => {
    try {
      if (
        !newProduct.name ||
        !newProduct.img ||
        !newProduct.description ||
        !newProduct.price ||
        !newProduct.volume ||
        !newProduct.weight
      ) {
        alert('заповніть всі поля');

        return;
      }

      const productsRef = collection(db, `marketplace`);

      let img = '';
      if (newProduct.img) {
        img = await uploadPhotoToStorage(
          newProduct.img,
          newProduct.img.name,
          'marketplace'
        );
      }

      await addDoc(productsRef, {
        img: img,
        name: newProduct.name,
        description: newProduct.description,
        price: parseFloat(newProduct.price),
        weight: newProduct.weight,
        volume: newProduct.volume,
        visible: newProduct.visible,
        position: products.length,
      });
      const sendPush = getFunctions.httpsCallable('sendPushNotification');

      sendPush({
        topic: 'client',
        title: 'Новий продукт уже в додатку!',
        body: 'Ми додали новий продукт до Vbalone service.\nЗаходь в додаток і дізнавайся більше: 👉 Перейти в ÓFFER',
      });
      setNewProduct({
        img: null,
        name: '',
        description: '',
        volume: 0,
        weight: 0,
        price: 0,
        position: products.length,
        visible: true,
      });
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (error) {
      console.error('Помилка додавання товару:', error);
    }
  };

  const handleEditProduct = async (id) => {
    try {
      if (
        !editingProduct.name ||
        !editingProduct.img ||
        !editingProduct.description ||
        !editingProduct.price ||
        !editingProduct.volume ||
        !editingProduct.weight
      ) {
        alert('заповніть всі поля');
        return;
      }

      const productRef = doc(db, `marketplace`, id);

      let img = editingProduct.img;
      if (editingProduct.img && typeof editingProduct.img !== 'string') {
        img = await uploadPhotoToStorage(img, img.name, 'marketplace');
      }

      await updateDoc(productRef, {
        img,
        name: editingProduct.name,
        description: editingProduct.description,
        price: parseFloat(editingProduct.price),
        visible: editingProduct.visible,
        weight: editingProduct.weight,
        volume: editingProduct.volume,
      });
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }

      setEditingProduct(null);
    } catch (error) {
      console.error('Помилка редагування товару:', error);
    }
  };

  const handleDeleteProduct = async (id) => {
    try {
      const productRef = doc(db, `marketplace`, id);
      const productSnapshot = await getDoc(productRef);

      if (!productSnapshot.exists()) {
        console.error('Товар не знайдено');
        return;
      }

      const productData = productSnapshot.data();
      const productImgUrl = productData.img;

      if (productImgUrl) {
        const storage = getStorage();
        const imageRef = ref(storage, productImgUrl);
        await deleteObject(imageRef);
      }
      await deleteDoc(productRef);
    } catch (error) {
      console.error('Помилка видалення товару:', error);
    }
  };

  const moveProductUp = async (id, currentPosition) => {
    try {
      if (currentPosition === 0) return;

      const currentProductRef = doc(db, `marketplace`, id);
      const previousProduct = products.find(
        (product) => product.position === currentPosition - 1
      );

      if (!previousProduct) return;

      const previousProductRef = doc(db, `marketplace`, previousProduct.id);

      await updateDoc(currentProductRef, { position: currentPosition - 1 });
      await updateDoc(previousProductRef, { position: currentPosition });
    } catch (error) {
      console.error('Помилка переміщення товару вгору:', error);
    }
  };

  const moveProductDown = async (id, currentPosition) => {
    try {
      if (currentPosition === products.length) return;

      const currentProductRef = doc(db, `marketplace`, id);
      const nextProduct = products.find(
        (product) => product.position === currentPosition + 1
      );

      if (!nextProduct) return;

      const nextProductRef = doc(db, `marketplace`, nextProduct.id);

      await updateDoc(currentProductRef, { position: currentPosition + 1 });
      await updateDoc(nextProductRef, { position: currentPosition });
    } catch (error) {
      console.error('Помилка переміщення товару вниз:', error);
    }
  };
  return (
    <div className='marketplace'>
      <form
        className='product-form'
        onSubmit={
          editingProduct
            ? (e) => {
                e.preventDefault();
                handleEditProduct(editingProduct.id);
              }
            : (e) => {
                e.preventDefault();
                handleAddProduct(e);
              }
        }
      >
        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
              flex: 1,
              marginRight: 24,
            }}
          >
            <input
              type='text'
              name='name'
              placeholder='Назва'
              value={editingProduct ? editingProduct.name : newProduct.name}
              onChange={handleChange}
              className='input-field'
            />
            <textarea
              name='description'
              placeholder='Опис'
              value={
                editingProduct
                  ? editingProduct.description
                  : newProduct.description
              }
              onChange={handleChange}
              className='textarea-field'
            />
            <input
              name='volume'
              placeholder="Об'єм товау в упаковці (метрів кубічних)"
              value={editingProduct ? editingProduct.volume : newProduct.volume}
              onChange={handleChange}
              className='input-field'
            />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              flex: 1,
            }}
          >
            <input
              type='number'
              name='price'
              placeholder='Ціна'
              value={editingProduct ? editingProduct.price : newProduct.price}
              onChange={handleChange}
              className='input-field'
            />
            <div className='checkbox-container'>
              <label className='checkbox-label'>Видимий</label>
              <input
                type='checkbox'
                name='visible'
                checked={
                  editingProduct ? editingProduct.visible : newProduct.visible
                }
                onChange={(e) =>
                  handleChange({
                    target: { name: 'visible', value: e.target.checked },
                  })
                }
                className='checkbox'
              />
            </div>
            <input
              type='file'
              name='img'
              placeholder='Фото'
              ref={fileInputRef}
              onChange={handleChange}
              className='file-input'
            />

            <input
              name='weight'
              placeholder='Вага товау в упаковці (кг)'
              value={editingProduct ? editingProduct.weight : newProduct.weight}
              onChange={handleChange}
              className='input-field'
            />
          </div>
        </div>
        <button type='submit' className='submit-button'>
          {editingProduct ? 'Зберегти' : 'Додати'}
        </button>
        {editingProduct && (
          <button
            type='button'
            preventDefault
            onClick={() => setEditingProduct(null)}
            className='cancel-button'
          >
            Скасувати
          </button>
        )}
      </form>

      <ul className='product-list'>
        {products.map((product) => (
          <li key={product.id} className='product-item'>
            <div
              style={{
                flexDirection: 'column',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-evenly',
              }}
            >
              <button
                onClick={() => moveProductUp(product.id, product.position)}
                className='move-up-button'
                disabled={product.position === 0}
              >
                ↑
              </button>
              <div>{product.position + 1}</div>
              <button
                onClick={() => moveProductDown(product.id, product.position)}
                className='move-down-button'
                disabled={product.position === products.length - 1}
              >
                ↓
              </button>
            </div>
            <img
              src={product.img}
              alt={product.name}
              className='product-image'
            />
            <div className='product-details'>
              <h3 className='product-name'>{product.name}</h3>
              <p className='product-description'>{product.description}</p>
              <p className='product-price'>{`Ціна: ${product.price} грн   Вага: ${product.weight} Об'єм: ${product.volume}`}</p>
              <p
                className='product-visibility'
                style={{
                  backgroundColor: product.visible ? 'green' : 'red',
                  width: 'fit-content',
                  padding: '3px 8px',
                  borderRadius: 100,
                }}
              >
                {product.visible ? 'Видимий' : 'Прихований'}
              </p>
              <div className='action-buttons'>
                <button
                  onClick={() =>
                    setEditingProduct({ id: product.id, ...product })
                  }
                  className='edit-button'
                >
                  Редагувати
                </button>
                <button
                  onClick={() => handleDeleteProduct(product.id)}
                  className='delete-button'
                >
                  Видалити
                </button>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Marketplace;
